<footer>
  <div class="container">
      <div class="links text-center">
        <a routerLink="/user/membership-plans">Become a Member</a>
        <br />
        <a [routerLink]="['/landowner/profit']" target="_blank">List My Land</a>
        <br />
        <a [routerLink]="['/stories/hoffman']"> Stories</a>
        <br />
      </div>
    <div class="text-center">
      <a routerLink="/">
        <img class="oa-logo" src="../assets/images/oa-logo-orange_lg.png" alt=""/>
      </a>
      <div class="text-center social">
        <a href="https://www.facebook.com/outdooraccessinc/" target="facebook">
          <i class="fa-brands fa-facebook fa-2x" aria-hidden="true"></i>
        </a>
        <a href="https://twitter.com/outdoor_access" target="twitter">
          <i class="fa-brands fa-twitter fa-2x" aria-hidden="true"></i>
        </a>
        <a href="https://www.instagram.com/outdooraccess/" target="instagram">
          <i class="fa-brands fa-instagram fa-2x" aria-hidden="true"></i>
        </a>
        <a href="https://www.youtube.com/channel/UCMgXq7_6fjoRthsGTnIDSlw" target="youtube">
          <i class="fa-brands fa-youtube fa-2x" aria-hidden="true"></i>
        </a>
      </div>
    </div>
      <div class="links">
          5002 Monument Ave
          <br />
          Richmond, VA 23230
          <br />
      </div>
  </div>

  <div class="clearfix"></div>
  <div class="copyright">
    <div class="col-12 text-center">
      <a id="footer-help-link" [routerLink]="['/user/safety']">Safety Guidelines</a>
      <span class="bullet">&#8226;</span>
      <a id="footer-help-link" [routerLink]="['/aboutus/help']">Help</a>
      <span class="bullet">&#8226;</span>
      <a [routerLink]="['/user/privacypolicy']" target="_blank"> Privacy Policy</a>
      <span class="bullet">&#8226;</span>
      <a [routerLink]="['/user/terms-of-service']" target="_blank"> Terms of Service</a>
      <span class="bullet">&#8226;</span>
      <a [routerLink]="['/aboutus/news']">News</a>
      <span class="bullet">&#8226;</span>
      <a [routerLink]="['/contact-us']">Contact Us</a>
    </div>
    <div class="col-12 text-center">
      &copy; Outdoor Access <span id="copyright-year-text">{{ copyrightYear }}</span>
    </div>
  </div>
  <div class="clearfix"></div>
</footer>
